import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';



class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 20000;
    }

    // Login Page
    signUp = (mobile,reagent_code =  null) =>{
       return  axios.post( 'sign-up', {mobile, reagent_code}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }

       return  axios.post( 'users/update-profile', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getReagents = (params = null) => {
        return axios.get( `users/reagents`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getVendorReagents = (params = null) => {
        return axios.get( `users/vendor-reagents`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getProductGroups = (params) => {
        return axios.get( `products/groups`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getSlides = (params = null) => {
        return axios.get( `slideshows`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getVendors = (params = null) => {
        return axios.get( `products/vendors`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getFavoriteVendors = (params = null) => {
        return axios.get( `products/vendor-favorite-list`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getVendor = (id,params = null) => {
        return axios.get( `products/vendors/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    // Verify OTP Page
    getCart = (request) =>{
        return  axios.post( 'calculate-cart', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getAddresses = (params = null) => {
        return axios.get( `addresses`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeAddress = (request) =>{
        return  axios.post( 'addresses', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    storeOrder = (request) =>{
        return  axios.post( 'orders', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Orders History Page
    getOrders = (params = null) => {
        return axios.get( `orders`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getStatuses = (params = null) => {
        return axios.get( `statuses`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Request Page
    getOrder = (params = null , id) => {
        return axios.get( `orders/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //Product Page
    getProduct = (params = null , id) => {
        return axios.get( `products/products/${id}`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getProducts = (params = null) => {
        return axios.get( `products/products`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    searchProducts = (params = null) => {
        return axios.get( `products/search`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    DiscountsProducts = (params = null) => {
        return axios.get( `products/discounts`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    favoriteVendor = (id , params = null) => {
        return axios.get( `products/vendor-favorite/${id}`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getScores = (params = null) => {
        return axios.get( `user-scores`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getWalletDetail = (params = null) => {
        return axios.get( `wallets/transactions`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getScoreDetails = (vendorID,params = null) => {
        return axios.get( `user-scores/${vendorID}`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserGroups = (params = null) => {
        return axios.get( `users/groups`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getStates = (params = null) => {
        return axios.get( `locations/states`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getCities = (params = null) => {
        return axios.get( `locations/cities`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getAreas = (params = null) => {
        return axios.get( `locations/areas`, {
            headers,
            params
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    updateStatus = (request) =>{
        return  axios.patch( 'update-order-status', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    searchNeshanReverse = (lat,lng) => {
        const headers = {
            'api-key': 'service.f60fc93d90f247fc871d107834659638'
        };
        return axios.get( `https://api.neshan.org/v4/reverse?lat=${lat}&lng=${lng}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    deleteAddress = (id , params = null) => {
        return axios.delete( `addresses/${id}`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getAddress = (id) => {
        return axios.get( `addresses/${id}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateAddress = (id, request) =>{
        return  axios.patch( `addresses/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    sendInviteSMS = (request) =>{
        return  axios.post( 'users/invite-sms', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
}
const API = new Api();
export default API;